import React from "react";
import { CompanyList } from "../../../components/admin/Dashboard/mycompanies/CompanyList";
import FollowNewCom from "../../../components/admin/Dashboard/following/FollowNewCompanies";
const MyCompany = () => {
  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          <CompanyList />
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col pareek">
          <FollowNewCom type="request" />
        </div>
      </div>
    </>
  );
};

export default MyCompany;
